import { render, staticRenderFns } from "./MyRecord.vue?vue&type=template&id=ca9befe6&scoped=true&"
import script from "./MyRecord.vue?vue&type=script&lang=js&"
export * from "./MyRecord.vue?vue&type=script&lang=js&"
import style0 from "./MyRecord.vue?vue&type=style&index=0&id=ca9befe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9befe6",
  null
  
)

export default component.exports